module.exports = "/packs/course-small-marketing-first-7fc39fbbc4f38ff728fbf629f605f405.png";